const premiumConfig: { [prop: string]: any } = {
  motor: {
    tpl: {
      basicPremium: 'without_tax_premium',
      paPremium: 'pa_premium',
      vatPremium: 'vat',
      amountPayable: 'PlanPremiumAmount',
    },
    cpd: {
      basicPremium: 'base_premium',
      amountPayable: 'PlanPremiumAmount',
    },
  },
  travel: {
    travel: {
      basicPremium: 'base_premium',
      vatPremium: 'vat',
      amountPayable: 'PlanPremiumAmount',
    },
  },
  pa: {
    pa: {
      basicPremium: 'base_premium',
      vatPremium: 'vat',
      amountPayable: 'PlanPremiumAmount',
    },
  },
  health: {
    health: {
      basicPremium: 'base_premium',
      vatPremium: 'vat',
      amountPayable: 'PlanPremiumAmount',
    },
  },
};

export default premiumConfig;
